import React from 'react'
import styled from 'styled-components'
import { bool, func } from 'prop-types'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { white, black } from 'styles/colors'
import { media, mediaDown } from 'styles/media'
import Cart from './Cart'
import MobileNav from 'components/MobileNav/index'
import Logo from 'images/logo.svg'
import Mark from 'images/logo-mark.svg'
import { navHeight, navHeightMobile, animationTime, animationCurve } from 'styles/global'
import AccountDropdown from './AccountDropdown'
import ProductsMenu from './ProductsMenu'
import RewardsDropdown from './RewardsDropdown'
import NavItem from 'components/Nav/NavItem'
import ProvinceSelector from 'components/Nav/ProvinceSelector'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${spacing.large};
  color: ${props => (props.transparent ? white : black)};
  height: ${navHeightMobile};

  ${media.medium`
    height: ${navHeight};
    padding: 0 ${spacing.xLarge};
  `};
`

export const DesktopLogo = styled(Logo)`
  transition: fill ${animationTime} ${animationCurve};
  fill: ${props => (props.transparent ? white : black)};
  width: 114px;
  height: 34px;

  ${media.xLarge`
    width: 124px;
    height: 37px;
  `};

  ${mediaDown.medium`
    display: none;
  `};
`

export const MobileLogo = styled(Mark)`
  transition: fill ${animationTime} ${animationCurve};
  fill: ${props => (props.transparent ? white : black)};
  width: 32px;
  height: 32px;

  ${media.medium`
    display: none;
  `};
`

export const LogoWrap = styled(props => <Link {...props} />)`
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`

const List = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  ${mediaDown.medium`
    display: none;
  `};
`

const ProvinceSelectorContainer = styled.div`
  ${mediaDown.medium`
    display: none;
  `};
`

const Nav = ({ transparent, hoverState, hoverFunc, hideLogin }) => (
  <Container transparent={transparent}>
    <MobileNav hideLogin={hideLogin} />
    <LogoWrap to="/" data-tracking="nav--link--image--Vype_Home">
      <DesktopLogo transparent={transparent ? 'true' : undefined} />
      <MobileLogo transparent={transparent ? 'true' : undefined} />
    </LogoWrap>
    <List>
      <ProductsMenu hoverFunc={hoverFunc} hoverState={hoverState} />
      <NavItem transparent={transparent} link="/subscribe/" label="Subscribe & Save" />
      <RewardsDropdown transparent={transparent} />
    </List>
    <ProvinceSelectorContainer>
      <ProvinceSelector transparent={transparent} noMargin={hideLogin} />
    </ProvinceSelectorContainer>
    {!hideLogin && <AccountDropdown transparent={transparent} />}

    <Cart transparent={transparent} />
  </Container>
)

Nav.propTypes = {
  transparent: bool,
  hoverFunc: func.isRequired,
  hoverState: bool,
  hideLogin: bool
}

export default Nav
